/**
 * 개발중인 페이지 및 테스트 페이지 
 * 상용서버에서의 접근불가 처리
 */
export default defineNuxtRouteMiddleware((to) => {

  const config = useRuntimeConfig();
  const envType = config.public.VITE_ENV_TYPE;
  const redirectPath: string[] = ['/agencyList', '/agencyMap'];

  if (envType === 'production' && redirectPath.includes(to.path)) {
    return navigateTo('/');
  }

});